import SaaSCTA from '@/components/SaaSCTA/SaaSCTA.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'ResearchPaid',
  data () {
    return {
      isLoading: {
        research: false
      }
    }
  },
  computed: {
    ...mapGetters(['activeWorkspace']),
    hasActiveSubscription () {
      if (!this.activeWorkspace) return false
      const activeSubscription = this.activeWorkspace.type === 'saas' && this.activeWorkspace.subscription_active
      if (activeSubscription) this.keywordLimit = this.keywordLimitPaid
      return activeSubscription
    }
  },
  components: {
    SaaSCTA
  }
}
